<template>
  <tr>
    <td data-th="Product">
      <div class="row">
        <div class="col-sm-2 d-none d-sm-block">
          <img :src="itemPhoto" alt="..." class="img-fluid" />
        </div>
        <div class="col-sm-10">
          <h4 class="nomargin">
            {{ cartItem.name }}
            <span v-if="cartItem.deliveryPriority" class="badge badge-pill badge-info">Delivery</span>
          </h4>

          <p>{{ cartItem.description }}</p>
        </div>
      </div>
    </td>
    <td data-th="Price">
      {{ cartItem.price | currency('Bs.', 2, {
      thousandsSeparator: ".",
      decimalSeparator: ",",
      symbolOnLeft: true,
      spaceBetweenAmountAndSymbol: true
      })
      }}
      <br />
      <template v-if="rate">
        ({{ itemPriceUSD | currency('$', 2, {
        thousandsSeparator: ".",
        decimalSeparator: ",",
        symbolOnLeft: true,
        spaceBetweenAmountAndSymbol: true
        })
        }})
      </template>
    </td>
    <td data-th="Quantity">
      <spinner
        :quantity="cartItem.count"
        :saleLimit="cartItem.saleLimit"
        @update="(value) => cartItem.count = value"
      />
    </td>
    <td data-th="Subtotal" class="text-center">
      {{ subtotal | currency('Bs.', 2, {
      thousandsSeparator: ".",
      decimalSeparator: ",",
      symbolOnLeft: true,
      spaceBetweenAmountAndSymbol: true
      })
      }}
      <br />
      <template v-if="rate">
        ({{ subtotalPriceUSD | currency('$', 2, {
        thousandsSeparator: ".",
        decimalSeparator: ",",
        symbolOnLeft: true,
        spaceBetweenAmountAndSymbol: true
        })
        }})
      </template>
    </td>
    <td class="actions" data-th>
      <button class="btn btn-danger btn-sm" @click="removeItem">
        <i class="fas fa-trash-alt"></i>
      </button>
    </td>
  </tr>
</template>

<script>
const Spinner = () => import("../common/Spinner");
import ItemMixins from "./ItemMixins";
export default {
  mixins: [ItemMixins],
  props: ["cartItem"],
  components: {
    Spinner
  }
};
</script>
